import { useState } from "react";
import { faqItems } from "@/mocks/gossip";

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="guide" className="scroll-mt-20 bg-background-100/70">
      <div className="mx-auto max-w-[1440px] px-4 py-10 md:px-8 md:py-14">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <p className="flex items-center gap-2 text-sm font-semibold text-secondary-600">
              <i className="ri-question-answer-line text-base" aria-hidden="true"></i>
              GUIDE
            </p>
            <h2 className="mt-2 text-3xl font-bold text-foreground-950 md:text-4xl">吃瓜指南</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              关于爆料网的热料来源、实锤与传闻的区别，以及遇到问题如何反馈，一次讲清楚。理性吃瓜，快乐吃瓜，才是真会吃瓜。
            </p>
            <a
              href="#subscribe"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-secondary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-secondary-600"
            >
              <i className="ri-mail-send-line text-base" aria-hidden="true"></i>
              订阅吃瓜快讯
            </a>
          </div>

          <div className="lg:col-span-8">
            <div className="space-y-3">
              {faqItems.map((item, idx) => {
                const open = openIdx === idx;
                return (
                  <div
                    key={item.q}
                    className={`overflow-hidden rounded-2xl border transition-colors ${
                      open ? "border-primary-300 bg-background-50" : "border-background-200 bg-background-50/60"
                    }`}
                  >
                    <h3>
                      <button
                        type="button"
                        onClick={() => setOpenIdx(open ? -1 : idx)}
                        aria-expanded={open}
                        className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                      >
                        <span className="flex items-center gap-3">
                          <span
                            className={`grid h-6 w-6 shrink-0 place-items-center rounded-full text-xs font-bold ${
                              open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                            }`}
                          >
                            {idx + 1}
                          </span>
                          <span className="text-[15px] font-semibold text-foreground-900">{item.q}</span>
                        </span>
                        <i
                          className={`ri-arrow-down-s-line text-xl text-foreground-500 transition-transform ${open ? "rotate-180" : ""}`}
                          aria-hidden="true"
                        ></i>
                      </button>
                    </h3>
                    {open && (
                      <div className="px-5 pb-5 pl-14 text-sm leading-relaxed text-foreground-600 md:px-6 md:pl-14">
                        {item.a}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}